import Button from "../Button";

export type MultiSelectModalProps = {
    title: string;
    message: string;
    onAccept: () => void;
    onReject: () => void;
};

export default function MultiSelectModal({ title, message, onAccept, onReject }: MultiSelectModalProps) {
    return (
        <>
            <div
                className="modal fade show"
                style={{ display: 'block' }}
                tabIndex={-1}
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content text-center p-4">
                        <div className="modal-body py-4">
                            <div className="text-success mb-3">
                                <i className="fas fa-check-circle" style={{ fontSize: '4rem' }} />
                            </div>
                            <h5 className="mb-2">{title}</h5>
                            <p className="text-muted mb-0">
                                {message}
                            </p>
                        </div>
                        <div className="modal-footer border-0 justify-content-center pb-4">
                            <Button
                                type="button"
                                className="btn btn-primary"
                                onClick={onAccept}
                            >
                                Tamam
                            </Button>
                            <Button
                                type="button"
                                className="btn btn-outline-primary ms-2"
                                onClick={onReject}
                            >
                                İptal
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    )
}

export type MultiSelectModalWithChildrenProps = {
    onAccept: () => void;
    onReject: () => void;
    acceptText?: string;
    rejectText?: string;
    dialogClassName?: string;
    children: React.ReactNode;
};

export function MultiSelectModalWithChildren({
    onAccept,
    onReject,
    acceptText = 'Tamam',
    rejectText = 'İptal',
    dialogClassName,
    children,
}: MultiSelectModalWithChildrenProps) {
    return (
        <>
            <div
                className="modal fade show"
                style={{ display: 'block' }}
                tabIndex={-1}
                aria-modal="true"
                role="dialog"
            >
                <div className={`modal-dialog modal-dialog-centered ${dialogClassName ?? ''}`}>
                    <div className="modal-content text-center p-4">
                        <div className="modal-body py-4">
                            {children}
                        </div>
                        <div className="modal-footer border-0 justify-content-center pb-4">
                            <Button
                                type="button"
                                className="btn btn-primary"
                                onClick={onAccept}
                            >
                                {acceptText}
                            </Button>
                            <Button
                                type="button"
                                className="btn btn-outline-primary ms-2"
                                onClick={onReject}
                            >
                                {rejectText}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    )
}